import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Input from 'react-bootstrap-myui/lib/Input'

class Checkbox extends React.Component {
  static propTypes = {
    data: PropTypes.bool,
    onChange: PropTypes.func,
    chart: PropTypes.object,
    disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  };

  constructor(props) {
    super(props)
    this.state = {
      checked: props.data || false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.data, nextProps.data)) {
      this.setState({
        checked: nextProps.data || false
      })
    }
  }

  render() {
    const { checked } = this.state
    let { disabled } = this.props
    if (_.isUndefined(disabled)) {
      disabled = false
    } else {
      disabled = _.isFunction(disabled) ? disabled(this.props.chart) : !!disabled
    }

    return (
      <div style={{ textAlign: 'right' }} className={`checkbox-container${disabled ? ' disabled' : ''}`}>
        <Input
          label=" "
          type="checkbox"
          checked={checked}
          onClick={this.handleCheckChange.bind(this)}
          onChange={() => { }}
          disabled={disabled}
        />
      </div>
    )
  }

  handleCheckChange(e) {
    const { checked } = e.target
    this.setState({
      checked
    }, () => {
      this.props.onChange(checked)
    })
  }
}

export default Checkbox
